(function() {
	angular.module('meanApp').controller('homeCtrl', homeCtrl);

	homeCtrl.$inject = [
		'$scope',
		'$rootScope',
		'$location',
		'authentication',
		'loginModal',
		'searchModal',
		'context',
		'$state'
	];
	function homeCtrl($scope, $rootScope, $location, authentication, loginModal, searchModal, context, $state) {
		var vm = this;
		/*vm.triggerFacebook = function () {
			if ( FB && FB.XFBML) {
  				FB.XFBML.parse();
  			}
		};*/

		context.set({
			href : '/about',
			contextName: 'Home',
			iconAction: 'info',
			goBack: false
		});

		vm.width = window.innerWidth;
		vm.height = window.innerHeight - vm.width / 5;
		if (vm.width < 768) {
			//height is bigger
			if (vm.width < vm.height) {
				vm.url = '/api/images/saladspinach-min.jpg?dim=250x350';
			} else {
				vm.url = '/api/images/saladspinach-min.jpg?dim=350x250';
			}
		} else if (vm.width < 992) {
			vm.url = '/api/images/saladspinach-min.jpg?dim=600';
		} else {
			vm.url = '/api/images/saladspinach-min-30.jpg?dim=850';
			//vm.url = '/api/images/saladspinach-min-blur.jpg?dim=900'
			//test
		}
		vm.loaded = false;
		vm.tabSelected = 0;
		vm.email = '';
		vm.provider = 'local';
		vm.isHidden = false; //routeParams.emailSaved ? true : false;

		vm.showSendEmail = false;

		vm.nutrition = {
			bacon: {
				first: {
					title: 'Lettre A',
					text:
						"Le meilleur score nutritionnel qu'un repas puisse obtenir au code 5 couleurs dit '5-C' élaboré par le professeur Hercberg."
				},
				second: {
					text: 'Quantité de protéines présente dans les fraises',
					title: '0%'
				},
				third: {
					text: 'Quantité de matières grasses saturées présente dans les fraises',
					title: '0%'
				},
				fourth: {
					text: 'Nombre de calories pour 100g de fraise',
					title: '33'
				}
			},
			strawberry: {
				first: {
					title: 'Lettre E',
					text:
						"Le score nutritionnel le plus faible qu'un repas puisse obtenir au code 5 couleurs dit '5-C' élaboré par le professeur Hercberg"
				},
				second: {
					text: 'Quantité de protéines présente dans le bacon grillé',
					title: '37%'
				},
				third: {
					text: 'Quantité de matières grasses saturées présente dans le bacon grillé',
					title: '14%'
				},
				fourth: {
					text: 'Nombre de calories pour 100g de bacon grillé',
					title: '541'
				}
			}
		};

		vm.selectTab = function(tabNumber) {
			console.log('select tab in home controller');
			vm.tabSelected = tabNumber;
			window.scrollTo(0, 0);
		};

		vm.goToIntermediateSearch = function() {
			//if on mobile YES, otherwise must go to the direct search by tag
			/*if($rootScope.isMobile) {
                searchModal.open();
            }
            else {*/
			$state.go('recipeSearchStep', {
				step: 1
			});
			//}
		};

		vm.goTo = function(hash) {
			$location.hash(hash);
		};
	}
})();
